module.exports = __webpack_public_path__ + "img/chart_2.859e1629.png";